document.addEventListener('alpine:init', () => {
  Alpine.data('pupIgDataEnd', () => ({

    _supabase: null,
    email: '',
    originalUrl: '',
    pupName: '',
    sunflower_glasses_watermarked: null,
    sunflower_glasses_clean: null,
    selectedVariant: '',
    photoLand: window.pupIgStrings.photoLand,
    step: 1,
    results: {},
    resultImageUrl: null,
    variants: [
      { id: 1, emoji: '🐾', label: window.pupIgStrings.variant1_label },
      { id: 2, emoji: '🎄', label: window.pupIgStrings.variant2_label },
      { id: 3, emoji: '🌸', label: window.pupIgStrings.variant3_label },
    ],

    init() {
        const url = 'https://shmjvbgnblpwrsghxjpr.supabase.co'
        const key = 'sb_publishable_z9frF4Yd8QxAC19Lonpg7g_mSDAHBPT'
        this._supabase = supabase.createClient(url, key);
    },

    async findPup() {
  const emailToSearch = this.email.trim().toLowerCase();

  try {
    const { data, error } = await this._supabase
      .from('users')
      .select(`
        dog_name, 
        generated_url, 
        generated_door_b_url_watermarked, 
        generated_door_b_url_clean,
        generated_party_hat_url_clean,
        generated_clever_hat_url_clean,
        generated_halloween_hat_url_clean,
        generated_santa_hat_url_clean,
        generated_bunny_hat_url_clean,
        generated_thanksgiving_hat_url_clean,
        generated_flower_crown_hat_low_url_clean,
        generated_heart_glasses_url_clean,
        generated_apple_glasses_url_clean,
        generated_year_glasses_url_clean,
        generated_donut_bandana_url_clean,
        generated_us_bandana_url_clean
      `)
      .eq('email', emailToSearch)
      .maybeSingle();

    if (error) throw error;

    if (data) {
      this.pupName = data.dog_name;
      this.originalUrl = data.generated_url;
      this.sunflower_glasses_watermarked = data.generated_thanksgiving_hat_url_clean;
      this.variants[0].watermarked = this.sunflower_glasses_watermarked;
      
      this.sunflower_glasses_clean = data.generated_thanksgiving_hat_url_clean;
      this.variants[0].image = this.sunflower_glasses_clean;

      // Save the complete results object so your grid function can access them easily
      this.results = {
        sunflower_glasses: { clean: data.generated_door_b_url_clean },
        party_hat: { clean: data.generated_party_hat_url_clean },
        clever_hat: { clean: data.generated_clever_hat_url_clean },
        halloween_hat: { clean: data.generated_halloween_hat_url_clean },
        santa_hat: { clean: data.generated_santa_hat_url_clean },
        bunny_hat: { clean: data.generated_bunny_hat_url_clean },
        thanksgiving_hat: { clean: data.generated_thanksgiving_hat_url_clean },
        flower_crown_hat_low: { clean: data.generated_flower_crown_hat_low_url_clean },
        heart_glasses: { clean: data.generated_heart_glasses_url_clean },
        apple_glasses: { clean: data.generated_apple_glasses_url_clean },
        year_glasses: { clean: data.generated_year_glasses_url_clean },
        donut_bandana: { clean: data.generated_donut_bandana_url_clean },
        us_bandana: { clean: data.generated_us_bandana_url_clean }
      };

      this.step = 2;
      this.pingGen();
    } else {
      alert('No pup found!');
    }

  } catch (err) {
    console.error('Supabase Fetch Error:', err);
  }
},
async generateGridCard() {
  console.log('Grid generation started');
  
  if (!this.results) {
    console.error("No variant images available to build the grid.");
    return;
  }

  // Define the exact order of keys matching your desired visual display

  const variantKeys = [
    'year_glasses', 'heart_glasses', 'clever_hat',
    'bunny_hat', 'flower_crown_hat_low', 'donut_bandana',
    'us_bandana', 'sunflower_glasses', 'apple_glasses',
    'halloween_hat', 'thanksgiving_hat', 'santa_hat'
  ]

  const loadImage = (src) => new Promise((resolve, reject) => {
    if (!src) return resolve(null); // Safely handle missing links
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null); // Keep grid going even if one image fails

    const cacheBuster = src.includes('?') ? `&cb=${Date.now()}` : `?cb=${Date.now()}`;
    img.src = src + cacheBuster;
  });

  try {
    // 1. Load all 12 images concurrently
    const imagePromises = variantKeys.map(key => loadImage(this.results[key]?.clean));
    const loadedImages = await Promise.all(imagePromises);

    // 2. Setup grid layout dimensions
    const cols = 3;
    const rows = 4;
    
    const cardWidth = 400;   // High-res width for an individual card cell
    const cardHeight = 500;  // High-res height for an individual card cell
    const padding = 30;      // Empty gap between individual cards
    
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // Calculate total layout width and height
    canvas.width = (cols * cardWidth) + ((cols + 1) * padding);
    canvas.height = (rows * cardHeight) + ((rows + 1) * padding);

    // Fill entire canvas background with white
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // 3. Draw the cells loop
    loadedImages.forEach((img, index) => {
      if (!img) return;

      const col = index % cols;
      const row = Math.floor(index / cols);

      // Top-left coordinate offsets for the current card block
      const cardX = padding + col * (cardWidth + padding);
      const cardY = padding + row * (cardHeight + padding);

      // Draw the rounded/soft card background
      ctx.fillStyle = '#fdf6ee'; // Warm cream background matching your reference image
      ctx.beginPath();
      ctx.roundRect(cardX, cardY, cardWidth, cardHeight, 24); // 24px corner radius
      ctx.fill();

      // Sizing constraints for the inner dog portrait
      const imgSize = cardWidth * 0.75;
      const imgX = cardX + (cardWidth - imgSize) / 2;
      const imgY = cardY + (cardHeight * 0.1); // Shifted slightly towards the top

      // Layer the dog image variant onto the card
      ctx.drawImage(img, imgX, imgY, imgSize, imgSize);

      // 4. Render the dynamic text name below the dog portrait
      ctx.fillStyle = '#000000';
      ctx.font = 'bold 36px sans-serif';
      ctx.textAlign = 'center';
      
      const textX = cardX + (cardWidth / 2);
      const textY = cardY + cardHeight - (cardHeight * 0.12);
      
      // ctx.fillText(this.pupName || 'Kalina', textX, textY);
    });

    // 5. Update state and trigger download anchor injection
    this.resultImageUrl = canvas.toDataURL('image/png');

    // const downloadLink = document.createElement('a');
    // downloadLink.href = this.resultImageUrl;
    // downloadLink.download = `${this.pupName || 'pup'}-stickers-grid.png`;
    // document.body.appendChild(downloadLink);
    // downloadLink.click();
    // document.body.removeChild(downloadLink);

  } catch (error) {
    console.error("Failed to generate grid composite image:", error);
  }
},
    pingGen() {
      fetch('https://sharkadoodle-style-face-only-8256783-v73.app.beam.cloud/ping', {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer wclFmmq7FMXAh1Qoi___OsXJyAd7u0B5wL4EbY-z0gbS33YR_cFNVXOOBY7NVzEcY59uTGRD5AtZsvgbUbzUTw==',
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Success:', data);
    })
    .catch(error => {
      console.error('Error:', error);
    });
   },

    async getBase64(fileUrl) {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch URL: ${response.statusText}`);
      }
      file = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

   async generateOld() {
      this.step = 4;
    this.errorMessage = '';
    
    // https://sharkadoodle-style-face-only-8256783-v52.app.beam.cloud/generate
    // https://api.mockfly.dev/mocks/5f002a10-bd0b-4acd-b384-90e5a0b8191c/generate
    const url = 'https://sharkadoodle-beam-wake.sharkadoodle-wake.workers.dev/face';
    const token = 'wclFmmq7FMXAh1Qoi___OsXJyAd7u0B5wL4EbY-z0gbS33YR_cFNVXOOBY7NVzEcY59uTGRD5AtZsvgbUbzUTw==';
    const base64Image = await this.getBase64(this.originalUrl);
   
    const payload = {
        email: this.email,
        encoded_images: [
            base64Image
        ]
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        
        const apiData = await response.json();
        
        if (apiData && apiData.images) {
            // Loop through the incoming API images
            apiData.images.forEach((item, index) => {
                // Check if an object already exists at this index in your Alpine array
                if (this.variants[index]) {
                    // Update only the image and watermarked properties directly
                    this.variants[index].image = item.original;
                    this.variants[index].watermarked = item.watermarked;
                }
            });
        }

    } catch (error) {
        this.errorMessage = 'Failed to update variants.';
        console.error(error);
    } finally {
      // this.percent = 100;
      this.generating = false;
    }
    },
    async trackDoorBRetrieved() {
      try {
        const { data, error } = await this._supabase.functions.invoke('dynamic-service', {
          body: {
            event_type: 'Door B - Retrieved',
            email: this.email,
            dog_name: this.pupName,
            design_id: null,
            preview_image_url: this.sunflower_glasses_clean
          }
        });

        // Handle errors returned by Supabase or the Edge Function
        if (error) {
          if (error.context) {
            const errorBody = await error.context.json().catch(() => null);
            console.error('Edge Function Error Response:', errorBody);
            throw new Error(errorBody?.error || errorBody?.details || 'Failed to trigger event');
          }
          throw error;
        }

        console.log('Door B event logged successfully:', data);
        return data;

      } catch (err) {
        console.error('Door B tracking failed:', err.message || err);
        throw err;
      }
    },

async finish(productId, isBundle = false) {
    // Determine which image state to use based on the button flag
    const imageToSend = isBundle ? this.resultImageUrl : this.sunflower_glasses_clean;

    const formData = {
        'items': [{
            'id': productId,
            'quantity': 1,
            'properties': {
              'aiImage': imageToSend, // Sends grid if true, single if false
              'numberOfDogs': 1
            }
        }]
    };
  
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });
        const responseData = await response.json();
    } catch (error) {
        window.test = error;
        console.error(`Error adding items to cart:`, error);
    }

    window.location = '/cart';
},


    dotClass(n) {
      if (n < this.step)   return 'pup-dot pup-dot--done';
      if (n === this.step) return 'pup-dot pup-dot--active';
      return                      'pup-dot pup-dot--future';
    },
    lineClass(n) {
      return n < this.step ? 'pup-line pup-line--done' : 'pup-line pup-line--future';
    },
  
    //Loader
    percent: 30, 
    radius: 40,
    get circumference() { return 2 * Math.PI * this.radius },
    get strokeDashoffset() { return this.circumference - (this.percent / 100) * this.circumference },
    get isComplete() { return this.percent >= 100 },
    startLoader() {
      // Clear any existing interval just in case
      clearInterval(this.intervalId);
      
      this.intervalId = setInterval(() => {
        if (this.percent < 100) {
          this.percent++;
        } else {
          clearInterval(this.intervalId);
        }
      }, 100); } // 400ms * 100 steps = 40,000ms (40 seconds)
  })
  )}
)